import i18n from 'i18next'
import { formatNumber } from '../../packages/utils/numberFormatters'
import { IssueSingleItem } from '@finance-lab/utils/types'

const quantityLabelKeys = {
    right: ['pages.issues.quantityLabels.right', 'pages.issues.quantityLabels.rights'],
    share: ['pages.issues.quantityLabels.share', 'pages.issues.quantityLabels.shares'],
    unit: ['pages.issues.quantityLabels.unit', 'pages.issues.quantityLabels.units'],
    warrant: ['pages.issues.quantityLabels.warrant', 'pages.issues.quantityLabels.warrants'],
} as const

const label = (type: keyof typeof quantityLabelKeys, quantity: number, locale: string) => {
    const [singularKey, pluralKey] = quantityLabelKeys[type]
    const text = i18n.t(quantity === 1 ? singularKey : pluralKey)
    return `${formatNumber(quantity, { locale, decimals: 0 })} ${text}`
}

const quantityLabel = (issue: Parameters<typeof isUnit>[0], quantity: number, locale: string) => {
    return label(isUnit(issue) ? 'unit' : 'share', quantity, locale)
}

const rightsQuantityLabel = (quantity: number, locale: string) => label('right', quantity, locale)
const sharesQuantityLabel = (quantity: number, locale: string) => label('share', quantity, locale)
const unitsQuantityLabel = (quantity: number, locale: string) => label('unit', quantity, locale)
const warrantsQuantityLabel = (quantity: number, locale: string) => label('warrant', quantity, locale)

function isUnit(
    issue: Pick<IssueSingleItem, 'type' | 'hasWarrants' | 'warrants' | 'sharesInUnit' | 'unitExtraContent'>,
) {
    if (issue.type === 'Rights issue' || issue.type === 'IPO') {
        // maybe unit
        return (
            issue.hasWarrants || (issue.warrants?.length ?? 0) > 0 || issue.sharesInUnit !== 1 || issue.unitExtraContent
        )
    } else {
        // always share
        return false
    }
}

const isShare = (issue: Parameters<typeof isUnit>[0]) => !isUnit(issue)

export {
    isShare,
    isUnit,
    quantityLabel,
    rightsQuantityLabel,
    sharesQuantityLabel,
    unitsQuantityLabel,
    warrantsQuantityLabel,
}
